// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Paraguay from '../_raw/flag/icon_flag_paraguay.png';

export default () => <img src={Paraguay} alt="Paraguay" />;
